// Note: a save that went out but got no reply may or may not have reached the server, so rather than being
// lost it is queued under the id it was sent with. The server records that id when it applies a direct save
// and the sync endpoint skips an id it has recorded, so a save that did arrive is not applied twice. A reply
// of any kind, an error included, resolves rather than rejects, so only a missing reply falls through.
export async function sendDirect<T>(send: () => Promise<T>): Promise<T | null> {
  try {
    return await send()
  } catch {
    return null
  }
}
